import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from "react-router-dom";
import { AuthScreen } from "./auth/AuthScreen";
import { useContext } from "react";
import { AuthContext } from "./firebaseio/AuthContext";
import { RootRoute } from "./RootRoute";
import { PricingPage } from "./website/PricingPage";
import { PrivacyPolicyPage } from "./website/PrivacyPolicyPage";

export function Router() {
  const auth = useContext(AuthContext);

  const router = createBrowserRouter([
    // Marketing routes. These render without waiting on auth, which is what
    // makes them prerenderable and visible to crawlers.
    //
    // IMPORTANT: marketing pages and the app's main nav tabs share the root URL
    // namespace -- the "/*" route below resolves tabs by their slugs in
    // main_nav/mainNavDefinitions (see UrlContext). A marketing path that
    // matches a tab slug silently shadows that tab. Before adding a page here,
    // check it against those slugs: currently home, budgets, transactions,
    // balances, cash-flow, and the old reports.
    {
      path: "/privacy",
      element: <PrivacyPolicyPage />,
    },
    {
      path: "/pricing",
      element: <PricingPage />,
    },
    {
      path: "/auth/*",
      element: <AuthScreen></AuthScreen>,
      loader: () => {
        if (auth) {
          return redirect("/");
        }
        return null;
      },
    },
    // "/" and every app path share one route element on purpose -- see the
    // comment in RootRoute. React Router ranks "/privacy", "/pricing" and
    // "/auth/*" above this catch-all regardless of declaration order.
    {
      path: "/*",
      element: <RootRoute />,
    },
  ]);
  return <RouterProvider router={router}></RouterProvider>;
}
